module.exports = __webpack_public_path__ + "static/media/june_2025_2.cff61ab2.webp";